// import { Firestore } from '@google-cloud/firestore'
import { writable } from 'svelte/store'
import { Auth, Firestore } from '../config/firebase'

// import client from '../helpers/apollo'
// import currentUser from '../queries/currentUser'
// import login from '../mutations/login'

// answer-> https://svelte.dev/repl/f6e920e06c834b68af2c94c040409938?version=3.6.10

// Hi curious as to why this looses it's reactivity:
// https://svelte.dev/repl/932c803c37a449f58850acc11b3e528c?version=3.6.10

// ps: I know this is the right way:
// https://svelte.dev/repl/542d2b6123124d2cb71ba4e6be2c67a3?version=3.6.10

const LOGGED_OUT = {
  uid: null,
  email: null,
  displayName: null,
  isAdmin: false,
  clientID: null,
  clientName: null,
  loggedIn: false,
  token: '',
  requestStatus: 'done',
  error: [],
  panels: [],
}

function createAuth() {

  const { subscribe, set, update, get } = writable(LOGGED_OUT)

  return {
    subscribe: (cb) => {
      set({
        uid: (localStorage.uid) ? localStorage.uid : null,
        email: (localStorage.email) ? localStorage.email : null,
        displayName: (localStorage.displayName) ? localStorage.displayName : null,
        clientID: (localStorage.clientID) ? localStorage.clientID : null,
        clientName: (localStorage.clientName) ? localStorage.clientName : null,
        loggedIn: (localStorage.loggedIn) ? localStorage.loggedIn : false,
        token: (localStorage.token) ? JSON.parse(localStorage.token) : null,
        panels: (localStorage.panels) ? JSON.parse(localStorage.panels) : null,
        requestStatus: 'done',
        error: []
      })
      subscribe(cb)
      return () => {
        // console.log('custom unsubscribe logic')
      }
    },
    login: async (email, password) => {
    // login: async (firebase, email, password) => {
  
      update(oldAUth => {
        let newAuth = {...oldAUth}
        newAuth.error = null
        newAuth.requestStatus = 'checking'
        return newAuth
      })
      
      let errors = []

      // await firebase.auth().signInWithEmailAndPassword(email, password)
      await Auth.signInWithEmailAndPassword(email, password)
        .then( async (obj) => {
   
          // console.log(`Object => ${JSON.stringify(obj,null,2)}`)

          await localStorage.clear()
          
          const cloned = JSON.parse(JSON.stringify(obj.user))
          
          const { uid, email, displayName, providerData, stsTokenManager  } = cloned

          if (uid) {localStorage.uid = uid}
          if (email) {localStorage.email = email}
          if (displayName) {localStorage.displayName = displayName}
          if (stsTokenManager) {localStorage.token = JSON.stringify(stsTokenManager)}
          localStorage.loggedIn = true

          let clientID = ''
          let clientName = ''

          // let db = firebase.firestore()
          // let ref = db.collection("userMeta").doc(uid)
          let ref = Firestore.collection("userMeta").doc(uid)

          await ref.get().then( (doc) => {
            if (doc.exists) {
                let data = doc.data()
                // console.log("Document data:", JSON.stringify(data,null,2))
                clientID = data.defaultClientId
                clientName = data.defaultClientName
              } else {
                // doc.data() will be undefined in this case
                console.log("No such document!")
            }
          }).catch(function(error) {
              console.log("Error getting document:", error.message);
          })

          localStorage.clientID = clientID
          localStorage.clientName = clientName
          
          let pnl = await Firestore.collection("clients").doc(clientID).collection('panels').get()
          let panels = []
          pnl.forEach( doc => {
            let data = doc.data()  // dd = Doc Data
            data.id = doc.id
            panels.push(data)
          })

          localStorage.panels = JSON.stringify(panels)

          update(oldAUth => {
            let newAuth = {...LOGGED_OUT}
            newAuth = newAuth
            newAuth.uid = uid
            newAuth.email = email
            newAuth.displayName = displayName
            newAuth.token = JSON.parse(JSON.stringify(stsTokenManager))
            newAuth.clientID = clientID
            newAuth.clientName = clientName
            newAuth.panels = panels
            newAuth.loggedIn = true
            newAuth.error = null
            newAuth.requestStatus = 'done'
            newAuth = {...newAuth}
            // console.log(`newAuth ==> ${JSON.stringify(newAuth,null,2)}`)
            return newAuth
          })
        })
        .catch((error) => {
          // console.log(`Error ==> ${error}`)
          // console.log(`Error ==> ${JSON.stringify(error,null,2)}`)
          errors = [...errors, error]
          update(oldAUth => {
            let newAuth = {...LOGGED_OUT}
            newAuth.requestStatus = 'done'
            newAuth.error = errors[0]
            return newAuth
          })
        })
    },
    // logout: (firebase) => {
    logout: () => {
      set(LOGGED_OUT)
      localStorage.clear()
      // firebase.auth().signOut().then(() => {
      Auth.signOut().then(() => {
        // console.log('Sign-out successful.')
      }).catch((error) => {
        // console.log('A Sign-out error happened.')
      })      
      return LOGGED_OUT
    },
    currentUser: () => {
      return {
        uid: (localStorage.uid) ? localStorage.uid : null,
        email: (localStorage.email) ? JSON.parse(localStorage.email) : null,
        displayName: (localStorage.displayName) ? JSON.parse(localStorage.displayName) : null,
        clientID: (localStorage.clientID) ? JSON.parse(localStorage.clientID) : null,
        clientName: (localStorage.clientName) ? JSON.parse(localStorage.clientName) : null,
        loggedIn: (localStorage.loggedIn) ? JSON.parse(localStorage.loggedIn) : false,
        token: (localStorage.token) ? JSON.parse(localStorage.token) : null,
        panels: (localStorage.token) ? JSON.parse(localStorage.panels) : null,
        requestStatus: 'done',
        error: []
      }
    },
    setClient: async (client) => {
      // {"id":"neMXuH4I1SYDQoN9IioI","text":"DNAIQ","code":"DNAIQ"}
      let clientID = client.id
      let clientName = client.text

      localStorage.clientID = clientID
      localStorage.clientName = clientName

      let pnl = await Firestore.collection("clients").doc(clientID).collection('panels').get()
      let panels = []
      pnl.forEach( doc => {
        let data = doc.data()  // dd = Doc Data
        data.id = doc.id
        panels.push(data)
      })

      localStorage.panels = JSON.stringify(panels)

      update(oldAUth => {
        let newAuth = {...oldAUth}
        newAuth.clientID = clientID
        newAuth.clientName = clientName
        newAuth.panels = panels
        newAuth = {...newAuth}
        // console.log(`newAuth ==> ${JSON.stringify(newAuth,null,2)}`)
        return newAuth
      })
    }
  }
}

const AppAuth = createAuth()

export default AppAuth